const Company = [
  {
    path: '/statistics',
    name: 'Statistics',
    meta: { 
      auth: true, 
      needs_company: true,
      tab_name: 'Estatísticas',
      // roles: [Director, Manager, Supervisor],
    },
    component: () => import(`@/pages/statistics/Statistics.vue`)
  },
  // {
  //   path: '/company_info',
  //   name: 'CompanyInfo',
  //   meta: { 
  //     auth: true, 
  //     tab_name: 'Informações da Empresa',
  //     // roles: [Director, Manager, Supervisor],
  //   },
  //   //component: () => import(`@/pages/company/CreateCompany.vue`)
  // },
  // {
  //   path: '/company_financial_config',
  //   name: 'CompanyFinancialConfig',
  //   meta: { 
  //     auth: true, 
  //     tab_name: 'Configurações financeiras',
  //     // roles: [Director, Manager, Supervisor],
  //   },
  //   // component: () => import(`@/pages/company/ShowEvent.vue`)
  // },
  
]

export default Company
